import { render, staticRenderFns } from "./OntologyTraitDisease.vue?vue&type=template&id=53f3e528&"
import script from "./OntologyTraitDisease.vue?vue&type=script&lang=js&"
export * from "./OntologyTraitDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports